import CompteDetailView from "@/pages/super-admin/components/CompteDetailView";

export default function SuperAdminAgenceDetailPage() {
  return <CompteDetailView type="agence" />;
}